import { Component, OnDestroy, effect, inject } from "@angular/core";
import { RouterModule, ActivatedRoute } from "@angular/router";
import { toSignal } from "@angular/core/rxjs-interop";

import { CommercialSalesDataService } from "src/services/commercial/commercial-sales-data.service";
import { RightSidebarOptions, RightSidebarService } from "src/services/right-sidebar.service";
import { CommercialMapComponentsService } from "src/services/commercial/commercial-map-components.service";

import { EvSalesmapLayoutComponent } from "src/app/shared-components/ev-salesmap-layout/ev-salesmap-layout.component";
import { CommercialFilterComponent } from "../commercial-filter/commercial-filter.component";
import { CommercialSalesListComponent } from "./commercial-sales-list/commercial-sales-list.component";
import { CommercialSaleInfocardComponent } from "./commercial-sale-infocard/commercial-sale-infocard.component";
import { MapRightMenuButtonsComponent } from "../../../shared-components/map-right-menu-buttons/map-right-menu-buttons.component";
import { combineLatest, map, of } from "rxjs";
import { MapStateService } from "src/services/map/map-state.service";
import { CommonModule } from "@angular/common";
import { IMiniInfocardCommercial } from "src/models/commercial/IMiniInfocardDataCommercial.model";
import { PolyDrawService } from "polydraw";

@Component({
    selector: "app-commercial-sale",
    imports: [
        RouterModule,
        EvSalesmapLayoutComponent,
        CommercialFilterComponent,
        CommercialSalesListComponent,
        CommercialSaleInfocardComponent,
        MapRightMenuButtonsComponent,
        CommonModule,
    ],
    templateUrl: "./commercial-sale.component.html",
    styleUrl: "./commercial-sale.component.scss",
})
export class CommercialSaleComponent implements OnDestroy {
    private readonly commercialMapComponentsService = inject(CommercialMapComponentsService);
    private readonly commercialSalesDataService = inject(CommercialSalesDataService);
    private readonly rightSidebarService = inject(RightSidebarService);
    private readonly mapStateService = inject(MapStateService);
    private readonly polydrawService = inject(PolyDrawService);

    sales = toSignal(this.commercialSalesDataService.sales$);
    selectedSale = this.commercialSalesDataService.activeSale;

    selectedSidebar = this.rightSidebarService.selectedSidebar;
    rightSidebarOptions = RightSidebarOptions;

    polygonActive$ = of(false);
    showEmptyListView$ = combineLatest([this.mapStateService.mapZoomLevel$, this.polygonActive$, this.commercialSalesDataService.sales$]).pipe(
        map(([zoom, active, sales]) => (active ? false : zoom <= this.mapStateService.zoomLimitCommercial || sales?.data?.length === 0))
    );

    constructor() {
        effect(() => this.commercialMapComponentsService.updateLayers(this.sales()));

        this.polydrawService.removeAllFeatureGroups();
    }

    ngOnDestroy(): void {
        this.commercialMapComponentsService.updateLayers(null)
        this.commercialMapComponentsService.cleanup();        
    }
}
